(function () {
  'use strict';
  if (customElements.get('ridek-sun-cart')) return;
  // Enabled by Greg for the live Sun trial. October remains unpublished.
  // Native checkout pricing awaits Greg's user-led test.
  const config = Object.freeze({"distributionEnabled":true,"nativeDiscountConfigured":true,"productAvailable":true,"inventoryConfirmed":true,"startsAt":"2026-10-24T15:55:50.000Z","endsAt":"2026-11-07T16:55:50.000Z"});
  const previewKey = 'ridek-october-sun-first-free-choice';
  const quantityKey='ridek-october-sun-first-free-quantity';
  let pendingQuantity;
  function getPreviewQuantity(){try{return Math.max(1,Math.min(99,Number(sessionStorage.getItem(quantityKey))||1));}catch{return 1;}}
  function setPreviewQuantity(q){try{sessionStorage.setItem(quantityKey,String(q));}catch{}}
  const elements = new Set();
  let lastState, timer, pending = false, inProgress, wanted, pendingChoice, lastError, lastCartSignature;
  const root = window.Shopify?.routes?.root || '/';
  const endpoint = suffix => root + 'cart' + suffix;
  async function request(suffix, body) {
    const response = await fetch(endpoint(suffix),body ? {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)} : {credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}});
    const data = await response.json();
    if (!response.ok || data.errors || data.status >= 400) throw new Error('The Sun preview could not update. Please retry.');
    return data;
  }
  const syncer = window.RidekSunCart.createSync({read:()=>request('.js'),add:body=>request('/add.js',body),change:body=>request('/change.js',body),update:body=>request('/update.js',body)},config);
  function getPreviewChoice() {try{return sessionStorage.getItem(previewKey)==='yes';}catch{return false;}}
  function setPreviewChoice(value) {try{sessionStorage.setItem(previewKey,value?'yes':'');}catch{/* unavailable storage keeps the current choice only */}}
  function hasConfirmedFreeSun(state) {
    if (!state.active || !state.requested || !state.checkboxEligible || state.actual.blocked || state.actual.sunQuantity < 1) return false;
    const sunLines = (state.cart.items || []).filter(item => String(item.product_id) === window.RidekSunRules.SUN_PRODUCT || String(item.variant_id) === window.RidekSunRules.SUN_VARIANT);
    const credit = sunLines.reduce((total, item) => total + (item.line_level_discount_allocations || []).reduce((amount, allocation) => amount + (allocation.discount_application?.title === 'Prototype Sun — First One Free' ? Number(allocation.amount) || 0 : 0), 0), 0);
    const unitPrice = Number(sunLines[0]?.original_price);
    return unitPrice > 0 && credit === unitPrice && (state.actual.sunQuantity > 1 || state.actual.sunCents === 0);
  }
  function paint(state, error) {
    for (const element of elements) {
      if (!element.isConnected) {elements.delete(element);continue;}
      if (!state) {element.hidden = !error;if(error)element.querySelector('[data-sun-cart-status]').textContent=error;continue;}
      element.hidden = !(state.checkboxEligible || state.intended.tractorCaps > 0 || state.actual.sunQuantity > 0 || error);
      element.classList.toggle('is-active', state.active);
      const checkbox = element.querySelector('[data-sun-cart-checkbox]');
      checkbox.checked = state.requested;
      checkbox.disabled = pending || !state.checkboxEligible;
      element.querySelector('[data-sun-cart-choice]').hidden = !state.checkboxEligible;

      const auto=element.querySelector('[data-sun-cart-auto]');
      auto.hidden=!state.intended.hasTractor;
      auto.textContent=state.intended.blocked?state.intended.reason:'Tractor + Sun Spoke Clip: '+state.intended.tractorCaps+' Sun'+(state.intended.tractorCaps===1?'':'s')+' packed with your Tractor caps. No extra free Sun.';
      element.querySelector('[data-sun-cart-quantity]').textContent='Sun Spoke Clip — Prototype';
      element.querySelector('[data-sun-cart-gift]').hidden=false;
      const count=state.active?state.actual.sunQuantity:state.intended.expected;
      const cost=state.active?state.actual.sunCents:state.intended.expectedCents;
      const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:state.cart.currency||'USD'}).format(cost/100);
      const priceLabel = element.querySelector('[data-sun-cart-price]');
      const confirmedFree = hasConfirmedFreeSun(state);
      const offerTitle = element.querySelector('.ridek-sun-cart__choice-title');
      if (state.requested && !confirmedFree) offerTitle.textContent = element.dataset.selectedLabel;
      else offerTitle.innerHTML = element.dataset.offerLabel;

      priceLabel.classList.toggle('ridek-sun-cart__price--free', confirmedFree);
      if (confirmedFree) {
        const format = count === 1 ? element.dataset.freeSingle : element.dataset.freeMultiple;
        priceLabel.textContent = format.replace('__PRICE__', money).replace('__QUANTITY__', String(count));
      } else {
        priceLabel.textContent=count?count+' Sun'+(count===1?'':'s')+' · '+money+(state.active?'':' estimated'):'First one free with eligible caps. Extras $4.85 each.';
      }
      const controls=element.querySelector('[data-sun-cart-quantity-controls]');
      controls.hidden=!state.requested;
      const input=element.querySelector('[data-sun-cart-qty]');
      input.value=count||1;input.disabled=pending;
      element.querySelector('[data-sun-cart-note]').textContent=state.active?'Your Sun selection is a cart item and carries through to checkout. Uncheck to remove the selected Suns.':'Preview only. Selection and prices are examples; no Sun has been added to your cart or checkout.';
      element.querySelector('.ridek-sun-cart__flag').textContent=state.active?'First one’s free':'Prototype preview · Offer inactive';
      element.querySelector('[data-sun-cart-status]').textContent=error||state.note||(pending?'Updating…':'');

    }
  }
  async function refreshTotals() {
    const footer = document.querySelector('#main-cart-footer');
    const empty=lastState.cart.items.length===0;
    for(const element of document.querySelectorAll('cart-items,cart-drawer-items,cart-drawer'))element.classList.toggle('is-empty',empty);
    if(footer)footer.classList.toggle('is-empty',empty);
    const sections = ['cart-icon-bubble'];
    if(footer?.dataset.id)sections.push(footer.dataset.id);
    const summary=document.querySelector('[data-ridek-cart-summary]');
    const summaryId=summary?.closest('.shopify-section')?.id.replace('shopify-section-','');
    if(summaryId)sections.push(summaryId);
    const url = new URL(endpoint(''),location.origin);url.searchParams.set('sections',sections.join(','));
    const response = await fetch(url,{credentials:'same-origin',cache:'no-store'});
    if(!response.ok)throw new Error('Please refresh your cart to confirm totals.');
    const html = await response.json();
    for(const section of sections){
      if(!html[section])continue;
      const doc = new DOMParser().parseFromString(html[section],'text/html');
      if(section==='cart-icon-bubble'){
        const target=document.querySelector('#cart-icon-bubble'),source=doc.querySelector('.shopify-section');
        if(target&&source)target.innerHTML=source.innerHTML;
      }else if(section===summaryId){
        const source=doc.querySelector('[data-ridek-cart-summary]');
        if(summary&&source)summary.innerHTML=source.innerHTML;
      }else{
        const target=footer?.querySelector('.js-contents'),source=doc.querySelector('.js-contents');
        if(target&&source)target.innerHTML=source.innerHTML;
      }
    }
    if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')await publish(PUB_SUB_EVENTS.cartUpdate,{source:'ridek-sun',cartData:lastState.cart});
  }
  async function refresh() {
    clearTimeout(timer);
    if(inProgress){wanted=true;return inProgress;}
    pending=true;lastError='';paint(lastState);
    inProgress=(async()=>{
      try{
        const active=window.RidekSunCart.distributionAllowed(config,Date.now());
        const choice=active?pendingChoice:getPreviewChoice();
        pendingChoice=undefined;
        const quantity=active?pendingQuantity:getPreviewQuantity();
        pendingQuantity=undefined;
        const state=await syncer.sync(choice,quantity);
        const signature=JSON.stringify([state.cart.total_price,state.cart.items.map(item=>[item.key,item.quantity,item.final_line_price])]);
        const cartChanged=lastCartSignature!==undefined&&signature!==lastCartSignature;
        lastCartSignature=signature;
        lastState=state;
        if(!active)setPreviewChoice(state.requested);
        if(state.changed||cartChanged)await refreshTotals();
        return state;
      }catch(error){lastError=error.message;paint(lastState,lastError);throw error;}
      finally{pending=false;inProgress=undefined;paint(lastState,lastError);if(wanted){wanted=false;schedule();}}
    })();
    return inProgress;
  }
  function schedule(delay=80){clearTimeout(timer);timer=setTimeout(()=>refresh().catch(()=>{}),typeof delay==='number'?delay:80);}
  class SunCart extends HTMLElement {
    connectedCallback(){
      elements.add(this);
      const selectionChanged=event=>{
        if(!event.target.matches('[data-sun-cart-checkbox], [data-sun-cart-qty]'))return;
        // Never let Dawn treat this checkbox as a line quantity input.
        event.stopPropagation();
        if(!lastState?.checkboxEligible)return;

        const quantityChange=event.target.matches('[data-sun-cart-qty]');
        const chosen=quantityChange?true:event.target.checked;
        const quantity=quantityChange?Math.max(1,Math.min(99,Math.floor(Number(event.target.value)||1))):(chosen?Math.max(1,lastState.intended.expected):1);
        if(lastState.active){pendingChoice=chosen;pendingQuantity=quantity;}else{setPreviewChoice(chosen);setPreviewQuantity(quantity);}
        lastState=window.RidekSunCart.describe(lastState.cart,chosen,lastState.active,quantity);
        paint(lastState);
        schedule(event.type==='input'?400:80);
      };
      this.addEventListener('change',selectionChanged);
      this.addEventListener('input',event=>{if(event.target.matches('[data-sun-cart-qty]'))selectionChanged(event);});
      if(lastState)paint(lastState);
      schedule();
    }
    disconnectedCallback(){elements.delete(this);}
  }
  customElements.define('ridek-sun-cart',SunCart);
  function setup(){
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,event=>{if(event.source!=='ridek-sun')schedule();});
    const drawer=document.querySelector('cart-drawer');
    if(drawer)new MutationObserver(()=>{if(drawer.classList.contains('active'))schedule();}).observe(drawer,{attributes:true,attributeFilter:['class']});
    // Dawn and app-assisted cart updates do not always publish the same event.
    // Observe only the native cart regions; ignore our own status/quantity paints.
    const cartRegions=[document.querySelector('#main-cart-items'),drawer].filter(Boolean);
    for(const region of cartRegions)new MutationObserver(mutations=>{
      if(mutations.some(mutation=>{
        const target=mutation.target.nodeType===1?mutation.target:mutation.target.parentElement;
        return !target?.closest('ridek-sun-cart');
      }))schedule();
    }).observe(region,{childList:true,subtree:true});
    window.addEventListener('focus',schedule);
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
    const allowedForms=new WeakSet();
    document.addEventListener('submit',async event=>{
      const form=event.target;
      if(allowedForms.has(form)){allowedForms.delete(form);return;}
      if(event.submitter?.name!=='checkout')return;
      const active=window.RidekSunCart.distributionAllowed(config,Date.now());
      if(!active)return;
      event.preventDefault();event.stopImmediatePropagation();
      try{
        if(inProgress)await inProgress;
        const state=await refresh();
        if(!state.active||state.actual.blocked){paint(state,state.actual.reason||'The Sun offer is inactive. Please remove the Sun before checkout.');return;}
        allowedForms.add(form);form.requestSubmit(event.submitter);
      }catch{/* visible status already explains retry */}
    },true);
    schedule();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
})();




